// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ExpandDoubleVector } from '../../DoubleMatrix';
import { IndicatorFunctions } from '../../IndicatorFunctions';
import { iBuildInIndicator } from '../../iBuildInIndicator';
export const iATR = 'iATR';
export class IATR extends iBuildInIndicator {
    constructor(maPeriod, maMode) {
        super(1);
        this.FMaPeriod = maPeriod;
        this.FMaMode = maMode || 0;
        this.FTR = new ExpandDoubleVector();
    }
    get Name() {
        return iATR;
    }
    get Key() {
        return this.DefaultKey + this.FMaPeriod + this.FMaMode;
    }
    Refresh(count, newThread) {
        this.FTR.Dispose();
        this.FTR = new ExpandDoubleVector();
        super.Refresh(count, newThread);
    }
    // TODO: Було public NextBar (callBound, isHistory), але isHistory не буде
    // передаватися в iBuildInIndicator.NextBar, бо NextBar приймає лише один параметр
    NextBar(callBound) {
        this.FTR.Add(0.0);
        super.NextBar(callBound);
    }
    OnQuote(ci, callBound, callFromRefresh) {
        const Parent = this.Parent;
        if (!Parent) {
            return;
        }
        this.FTR[this.FTR.Length - 1] = Parent.GetTrueRange(this.Count - 1);
        if (this.Count >= this.FMaPeriod) {
            this.SetValue(IndicatorFunctions.CallMovingFunction(this.FMaMode, this.FTR, this.FMaPeriod, this.FTR.Length - 1), undefined, undefined);
        }
    }
    Dispose() {
        this.FTR.Dispose();
        super.Dispose();
    }
}
